import { createAction, createSlice } from "@reduxjs/toolkit";

export interface State {
    totalSystemTDH: string
}

export const initialState: State = {
    totalSystemTDH: ''
}

export const setOperatingFrequency = createAction("summary/setOperatingFrequency");
export const setRequiredSystemTDH = createAction("summary/setRequiredSystemTDH");

const summarySlice = createSlice({
    name: 'summary',
    initialState,
    reducers: {
        SetTotalSystemTDH(state, action) {
            state.totalSystemTDH = action.payload;
        },
    },
});

export const { SetTotalSystemTDH } = summarySlice.actions;
export default summarySlice.reducer;
